// extracted by mini-css-extract-plugin
module.exports = {"checkoutFooter":"az_mm","footerBox":"az_nm","copyright":"az_om","digicert":"az_pm"};